import React, { useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import "../../../styles/clientPage.css";
import BusinessStatsSlideoverClient from "./BusinessStatsSlideoverClient";
import BusinessStatsSlideoverInteraction from "./BusinessStatsSlideoverInteraction";
import { format } from "date-fns";
import ClientStatsManagerAnalystOverview from "./ClientStatsManagerAnalystOverview";
import UserTeam from "../../Analytics/UserTeam";
import { getUserAttributes } from "../../../utils/auth";
import useGlobalContext from "../../../context/useGlobalContext";

type TabKey = "client" | "interaction";

interface ClientStatsBusinessOverviewProps {
  isSlideOverOpen: boolean;
  slideOverParent?: string;
  activeStat: string | null;
  parentPageIdentifier?: string;
  customDateRange?: { startDate: string; endDate: string };
  userEmail?: string;
}
const ClientStatsBusinessOverview: React.FC<
  ClientStatsBusinessOverviewProps
> = ({ isSlideOverOpen, slideOverParent, activeStat, parentPageIdentifier, customDateRange, userEmail }) => {
  const [tabValue, setTabValue] = useState<TabKey>("client");
  const handleTabChange = (_event: React.SyntheticEvent, newValue: TabKey) => {
    setTabValue(newValue);
  };
  const [selectedUser, setSelectedUser] = useState<any | null>(null);
  const loggedInEmail = getUserAttributes()?.email;
  const { accountDetails } = useGlobalContext();
  const loggedInProfileOrgId = accountDetails?.profileOrgId ?? "";

  const formattedEndDate = customDateRange?.endDate
    ? format(new Date(customDateRange.endDate), "MMM dd yyyy")
    : null;

  return (
    <Box className="client-business-overview">
      {/* Tabs */}
      <Box
        className="client-interaction__tabs-container"
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2, // space between items
        }}
      >
        {/* Tabs */}
        <Tabs value={tabValue} onChange={(_e, val) => handleTabChange(_e, val)}>
          <Tab label="Client" value="client" />
          {/* <Tab label="Interaction" value="interaction" /> */}
        </Tabs>
        {/* UserTeam next to Tabs */}
        {parentPageIdentifier !== "user-analytics" && (
          <UserTeam
            setSelectedUser={setSelectedUser}
            display={false}
            loggedInEmail={loggedInEmail}
            loggedInProfileOrgId={loggedInProfileOrgId}
            showDropdown={true}
            showDomainFirst={false}
            parent_page="client_stats"
          />
        )}
        {/* Date at the end */}
        {formattedEndDate && (
          <span
            className="client-business__daterange__label"
            style={{ marginLeft: "auto" }} // pushes it to the far right
          >
            <h1>
              Week ending{" "}
              <span className="client-business__daterange__date">
               {formattedEndDate}
              </span>
            </h1>
          </span>
        )}
      </Box>

      {/* Tab Content */}
      <Box className="client-business-overview__content">
      {
        tabValue === "client" ? (
          (activeStat === "managerTime" || activeStat === "analystTime")
            ? <ClientStatsManagerAnalystOverview 
                isSlideOverOpen={isSlideOverOpen}
                slideOverParent={slideOverParent}
                activeStat = {activeStat}
                selectedUser={selectedUser}
                parentPageIdentifier={parentPageIdentifier}
                customDateRange={customDateRange}
                userEmail={userEmail}
                  />
            : (
                <BusinessStatsSlideoverClient
                  isSlideOverOpen={isSlideOverOpen}
                  slideOverParent={slideOverParent}
                  activeStat={activeStat}
                  selectedUser={selectedUser}
                  parentPageIdentifier={parentPageIdentifier}
                  customDateRange={customDateRange}
                  userEmail={userEmail}
                />
              )
        ) : (
          <BusinessStatsSlideoverInteraction />
        )
      }
      </Box>
    </Box>
  );
};

export default ClientStatsBusinessOverview;
